export default {
  options: {
    customProperties: true
  },
  light: true,
  themes: {
    light: {
      primary: {
        base: "#32383d",
        darken1: "#1e2329",
        lighten1: "#2c3e50"
      },
      secondary: {
        base: "#dcdcdd",
        darken1: "#515358",
        lighten1: "#f8f8f8"
      },

      accent: { base: "#4fa2b7" },
      success: "#417505",
      warning: "#F5A623",
      error: "#930012",
      danger: "#ed4337"
    }
  }
};



// WEBPACK FOOTER //
// ./src/theme.js